/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DailyActivityMonitoringLogDetailDto } from './dailyActivityMonitoringLogDetailDto.schema';

export const ICollectionOfDailyActivityMonitoringLogDetailDto = zod.array(zod.lazy(() => DailyActivityMonitoringLogDetailDto));

export type ICollectionOfDailyActivityMonitoringLogDetailDto = zod.input<typeof ICollectionOfDailyActivityMonitoringLogDetailDto>;
export type ICollectionOfDailyActivityMonitoringLogDetailDtoOutput = zod.output<typeof ICollectionOfDailyActivityMonitoringLogDetailDto>;
